module.exports = __webpack_public_path__ + "img/services-defalut.2a2c9dee.svg";